import {
  HomeOutlined,
  InventoryOutlined,
  LocalOfferOutlined,
  ManageAccountsOutlined,
  MoneyOutlined,
} from "@mui/icons-material";

export const navConfig = {
  "tour-owner": [
    { to: "/dashboard", icon: <HomeOutlined />, label: "Dashboard" },
    { to: "/tours", icon: <LocalOfferOutlined />, label: "View Tours" },
    { to: "/manage-booking", icon: <InventoryOutlined />, label: "Bookings" },
    { to: "/profile", icon: <ManageAccountsOutlined />, label: "My Account" },
  ],
  "tour-distributor": [
    {
      to: "/dashboard",
      icon: <HomeOutlined />,
      label: "Dashboard",
    },
    {
      to: "/tour-listings",
      icon: <LocalOfferOutlined />,
      label: "Tour Listings",
    },
    {
      to: "/pricing-rule-form",
      icon: <MoneyOutlined />,
      label: "Pricing Rules",
    },
    {
      to: "/manage-booking",
      icon: <InventoryOutlined />,
      label: "Bookings",
    },
    { to: "/profile", icon: <ManageAccountsOutlined />, label: "My Account" },
  ],
};
